import React, { useEffect, useState } from "react";
import "./styles.scss";

function DefaultInput({
  onChange,
  value,
  placeholder,
  label,
  name,
  isDisabled,
  inputStyle,
  type = "text",
  min,
  max,
}) {
  const [inputValue, setInputValue] = useState(value);

  useEffect(() => {
    onChange(inputValue);
  }, [inputValue]);

  useEffect(() => {
    setInputValue(value);
  }, [value]);

  function handleChange(e) {
    if (type === "number" && min && max) {
      setInputValue(resolveInputNumberInRange(e.target.value));
    } else {
      setInputValue(e.target.value);
    }
  }

  function resolveInputNumberInRange(inputValue) {
    if (inputValue < min) {
      return min;
    } else if (inputValue > max) {
      return max;
    } else {
      return inputValue;
    }
  }
  return (
    <fieldset className="default-input">
      <label htmlFor={name}>{label} </label>
      <input
        style={{ ...inputStyle }}
        className={`input ${value ? "active" : "inactive"}`}
        type={type}
        name={name}
        {...(min && { min })}
        {...(max && { max })}
        onChange={handleChange}
        placeholder={placeholder ?? ""}
        value={inputValue}
        readOnly={isDisabled ? true : false}
      />
    </fieldset>
  );
}

export default DefaultInput;
